import { Select, Tag, Checkbox, Divider, CheckboxChangeEvent } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useState } from "react";
import { allPayoutResultValues } from "types/constants.ts";
import { PayoutResult } from "types/enums.ts";
const { Option } = Select;

interface StatusMultiSelectProps {
    onChange?: (values: PayoutResult[]) => void;
    defaultValue?: PayoutResult[];
}

export const StatusMultiSelect = ({ onChange, defaultValue = allPayoutResultValues }: StatusMultiSelectProps) => {
    const { t: tUI } = usePaldockTranslation("ui.status-multiselect");
    const { t: tCommon } = usePaldockTranslation("common");
    const { t: tG } = usePaldockTranslation("general");
    const allValues = allPayoutResultValues;
    const statusOptions = [
        { value: PayoutResult.Approved, label: tG("payout_result.approved"), color: "green" },
        { value: PayoutResult.Pending, label: tG("payout_result.pending"), color: "gold" },
        { value: PayoutResult.Rejected, label: tG("payout_result.rejected"), color: "red" },
    ];
    const [values, setValues] = useState<PayoutResult[]>(defaultValue);
    const handleChange = (vals: PayoutResult[]) => {
        if (vals.length === 0) return;
        setValues(vals);
        onChange?.(vals);
    };

    const toggleAll = (e: CheckboxChangeEvent) => {
        const next = e.target.checked ? allValues : [];
        setValues(next);
        onChange?.(next);
    };

    return (
        <Select
            mode="multiple"
            placeholder={tUI("select_statuses")}
            style={{ minWidth: 240 }}
            value={values}
            onChange={handleChange}
            optionLabelProp="label"
            maxTagCount="responsive"
            dropdownRender={(menu) => (
                <>
                    <div style={{ padding: "8px 12px" }}>
                        <Checkbox
                            onChange={toggleAll}
                            checked={values.length === allValues.length}
                            indeterminate={values.length > 0 && values.length < allValues.length}
                            disabled={values.length === allValues.length}
                        >
                            {tCommon("select_all")}
                        </Checkbox>
                    </div>
                    <Divider style={{ margin: "4px 0" }} />
                    {menu}
                </>
            )}
            tagRender={(props) => {
                const { label, value, onClose } = props;
                const status = statusOptions.find((o) => o.value === value);
                const closable = values.length > 1;
                const color = status?.color ?? "default";

                return (
                    <Tag color={color} closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
                        {label}
                    </Tag>
                );
            }}
        >
            {statusOptions.map(({ value, label, color }) => (
                <Option key={value} value={value} label={label}>
                    <Tag color={color}>{label}</Tag>
                </Option>
            ))}
        </Select>
    );
};
